export enum ReviewVisibility {
  Public = "PUBLIC",
  Unpublished = "UNPUBLISHED",
  Archived = "ARCHIVED",
}
